import { render, staticRenderFns } from "./MediaWatcher.vue?vue&type=template&id=05445fcc"
import script from "./MediaWatcher.vue?vue&type=script&lang=js"
export * from "./MediaWatcher.vue?vue&type=script&lang=js"
import style0 from "./MediaWatcher.vue?vue&type=style&index=0&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports